import { eventHasRun } from '../../utils/eventTracker';
import getSection from '../../utils/getSection';
import getLinkLabel from '../../utils/getLinkLabel';
import getFormEventData from '../../utils/getFormEventData';

export const DDC_FORM_CHANGE = 'ddc.form.change';
export const DDC_FORM_FACETBROWSECHANGE = 'ddc.form.facetbrowsechange';
export const DDC_FORM_INVENTORYSEARCHLEADCHANGE =
	'ddc.form.inventorySearchLeadChange';

const isValidTag = (tagName, formChangeTypes = ['select']) =>
	formChangeTypes.map((type) => type.toUpperCase()).includes(tagName);

function change(win, event) {
	let eventObject;
	const {
		target,
		timeStamp,
		target: { name, type }
	} = event;

	if (!target?.classList?.contains?.('hidden')) {
		const form = target.closest('form');
		const isFacetBrowse = form.classList.contains('facetbrowse-ajax-form');
		const isSearchLeadForm = form.classList.contains(
			'inventory-search-lead-form'
		);
		const isSelect = target.tagName === 'SELECT';
		let eventType = DDC_FORM_CHANGE;

		if (isFacetBrowse) {
			eventType = DDC_FORM_FACETBROWSECHANGE;
		} else if (isSearchLeadForm) {
			eventType = DDC_FORM_INVENTORYSEARCHLEADCHANGE;
		}

		if (
			!eventHasRun(eventType, {
				timeStamp
			})
		) {
			// scoping controlled by the formChangeTypes preference
			// if you need more than SELECT fields to trigger form change the pref must be set
			// so that we do not add too many events to window.dataLayer for clients that do not need them
			if (
				isValidTag(
					target.tagName,
					win?.DDC?.WidgetData?.['ws-tracking']?.formChangeTypes
				) &&
				target?.closest?.('.hide-from-ws-tracking') === null // added to avoid internal event viewer tracking
			) {
				const {
					DDC: {
						dataLayer = {},
						dataLayer: { vehicles = [] } = {}
					} = {}
				} = win;
				const trackingId = form?.dataset?.formTrackingId;
				const eventData = {
					element: target,
					formEventId:
						form.querySelector('input[name="formEventId"]')
							?.value || '',
					label: name || '', // if a SELECT field this can be ovewritten below by the selected option's text
					fieldName: name || '', // this is the actual field name in the HTML
					linkType: type,
					...(trackingId && { trackingId }),
					...getFormEventData({
						form,
						vehicles,
						dataLayer
					})
				};

				const section = getSection(target);
				const customLinkLabel = getLinkLabel(target);

				if (section) {
					eventData.trackingSection = section;
				}

				if (customLinkLabel) {
					eventData.customLinkLabel = customLinkLabel;
				}

				if (isSelect) {
					const selectedOption = target.options[target.selectedIndex];
					const selectedText = selectedOption && selectedOption.text;
					if (!name && selectedText) {
						eventData.label = selectedText;
					}
					eventData.firstOptionText =
						(target.options.length > 0 && target.options[0].text) ||
						'';
					eventData.selectedValue =
						(selectedOption && selectedOption.value) || '';
				}

				const visibleSelects = $(form)
					.find('select')
					.filter(':visible');
				$.each(visibleSelects, (_index, element) => {
					const $element = $(element);
					const value = $element.val();

					if (value) {
						eventData[$element.attr('name')] = value;
					}
				});

				if (target.labels?.length) {
					eventData.text = target.labels[0].textContent.trim();
				}

				eventObject = {
					eventType,
					eventData
				};
			}
		}
	}

	return eventObject;
}

export default change;
